import { FC, useState } from 'react';
import { translate } from '../../i18n';
import { cardNumberInputStyles } from './styles';

export interface CardNumberInputProps {
  value?: string;
  onChange?: (digits: string) => void;
  label?: string;
  testID?: string;
}

const formatCardNumber = (digits: string): string => digits.match(/.{1,4}/g)?.join(' ') ?? '';

/**
 * CardNumberInput — Input de número de tarjeta, agrupado de a 4 dígitos.
 *
 * ✅ Estilos centralizados en styles.ts
 * ✅ i18n para label y placeholder
 * ✅ Cero Tailwind, cero hardcodes
 */
export const CardNumberInput: FC<CardNumberInputProps> = ({
  value = '',
  onChange,
  label,
  testID = 'card-number-input',
}) => {
  const [digits, setDigits] = useState(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 16);
    setDigits(digitsOnly);
    onChange?.(digitsOnly);
  };

  return (
    <div style={cardNumberInputStyles.container}>
      {label && (
        <label style={cardNumberInputStyles.label} htmlFor={testID}>
          {label}
        </label>
      )}
      <input
        id={testID}
        type="text"
        inputMode="numeric"
        placeholder={translate('paymentsUI.cardNumberInput.placeholder')}
        value={formatCardNumber(digits)}
        onChange={handleChange}
        data-testid={testID}
        aria-label={translate('paymentsUI.cardNumberInput.ariaLabel')}
        style={{
          ...cardNumberInputStyles.input,
          ...(digits.length === 16 && cardNumberInputStyles.inputComplete),
        }}
      />
    </div>
  );
};
